import script from "./inform.vue?vue&type=script&setup=true&lang=js"
export * from "./inform.vue?vue&type=script&setup=true&lang=js"

import "./inform.vue?vue&type=style&index=0&id=291ae94e&lang=scss"

const __exports__ = script;

export default __exports__